import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';

import FieldError from '@/forms/FieldError';
import Button from '@/ui/components/Button';
import InputField from '@/ui/components/Form/InputField';
import InputGroup from '@/ui/components/Form/InputGroup';
import SSNInput from '@/ui/components/Form/SSNInput';

import { Props } from './types';

const SecretForm = ({
  initialValues,
  isSubmitting,
  label = 'Secret',
  schema,
  submitHandler
}: Props) => {
  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm({
    defaultValues: initialValues,
    resolver: schema ? yupResolver(schema) : undefined
  });

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <InputGroup>
        {Object.keys(initialValues).map((key) => {
          return (
            <Controller
              key={key}
              control={control}
              name={key}
              render={({ field }) => {
                return 'ssn' in initialValues ? (
                  <SSNInput onChange={field.onChange} value={field.value} />
                ) : (
                  <InputField
                    id={label || 'secretValue'}
                    label={label}
                    onChange={field.onChange}
                    type="text"
                    value={field.value}
                  />
                );
              }}
            />
          );
        })}

        {errors.ssn && <FieldError message={String(errors.ssn.message)} />}
        {errors.secretValue && <FieldError message={String(errors.secretValue.message)} />}
      </InputGroup>

      <InputGroup>
        <Button disabled={isSubmitting} type="submit">
          Submit
        </Button>
      </InputGroup>
    </form>
  );
};

export default SecretForm;
